export function svgDataUrl(label, bg = '#e8f2ff', fg = '#0b5cab') {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160"><rect width="160" height="160" rx="24" fill="${bg}"/><text x="80" y="92" text-anchor="middle" font-family="Arial, sans-serif" font-size="56" font-weight="700" fill="${fg}">${label}</text></svg>`;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

export const defaultUserPicture = svgDataUrl('U', '#eeeeee', '#555555');
export const defaultProductPicture = svgDataUrl('P', '#e8f2ff', '#0b5cab');

export function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
